import "./styles/IPodLoadingOverlay.css";
import { useEffect, useRef, useState } from "react";

interface LoadingOverlayProps {
  bootTime: number;
}

const BOOT_MESSAGES = [
  "Welcome to Macintosh.",
  "Checking disks",
  "Starting network file system",
  "Starting internet services",
  "Login Window starting",
];

const IPodLoadingOverlay = ({ bootTime }: LoadingOverlayProps) => {
  const [msgIndex, setMsgIndex] = useState(0);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const audio = new Audio("/assets/themes/ipod/audio/mac_startup.mp3");
    audioRef.current = audio;
    audio.play().catch(() => {
      // pause silently if autoplay is blocked
    });
    return () => {
      audio.pause();
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    const interval = bootTime / (BOOT_MESSAGES.length + 1);
    const timers: number[] = [];

    BOOT_MESSAGES.forEach((_, i) => {
      timers.push(
        window.setTimeout(() => {
          setMsgIndex(i);
        }, interval * i),
      );
    });

    return () => timers.forEach((t) => clearTimeout(t));
  }, [bootTime]);

  return (
    <div className="macosx-boot-popup">
      <div className="macosx-boot-popup-inner">
        <div className="macosx-boot-logo">
          <img
            src="/assets/themes/ipod/boot/macosx-103_logo.png"
            alt="MacOSX Logo"
          />
          <span className="macosx-boot-logo-text">Mac OS X</span>
        </div>

        <div className="macosx-boot-status">
          <div className="macosx-boot-progress-bar">
            <div className="macosx-boot-progress-fill" />
          </div>
          <span className="macosx-boot-status-text">
            {BOOT_MESSAGES[msgIndex]}
          </span>
        </div>
      </div>
    </div>
  );
};

export default IPodLoadingOverlay;
